import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";
import ReactDOM from "react-dom/client";
import { supabase } from "./supabaseClient";
import "./Style/App.scss";

import HomePage from "./Components/HomePage/HomePage";
import AdminHome from "./Components/Admin/AdminHome";
import AdminLogin from "./Components/Admin/AdminLogin";
import LoadingScreen from "./Components/Pages/LoadingScreen";
import Rewards from "./Components/Pages/Rewards";
import Sponsors from "./Components/Pages/Sponsors";
import FucaParty from "./Components/Pages/FucaParty";
import HowToCome from "./Components/Pages/HowToCome";
import HomeScorers from "./Components/HomePage/HomeScorers";
import HomeChampionship from "./Components/HomePage/HomeChampionship";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import TermsOfUse from "./Components/Pages/TermsOfUse";
import Rules from "./Components/Pages/Rules";
import AdminInventory from "./Components/Admin/AdminInventory";
import KonobarHome from "./Components/Konobar/KonobarHome";
import KonobarInventoryEdit from "./Components/Konobar/KonobarInventoryEdit";
import KonobarStats from "./Components/Konobar/KonobarStats";
import BelaTurnir from "./Components/Pages/BelaTurnir";
import PageNotFound from "./Components/Pages/PageNotFound";
// import NewsPage from "./Components/HomePage/NewsPage";
import WebInProgress from "./Components/Pages/WebInProgress";
import Arhiva from "./Components/Pages/Arhiva";

const App = () => {
  const [session, setSession] = useState(null);
  const [showLoading, setShowLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");

  useEffect(() => {
    const currentPath = window.location.pathname.toLowerCase();
    const isBackendRoute =
      currentPath.includes("/admin") ||
      currentPath.includes("/konobar") ||
      currentPath.includes("/sank") ||
      currentPath.includes("/inventory");

    if (isBackendRoute) {
      setShowLoading(false);
    }

    const checkMaintenanceMode = async () => {
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

      if (!isLocalhost) {
        // POVLAČIMO DODATNE STUPCE IZ BAZE:
        const { data } = await supabase
          .from("site_settings")
          .select(
            "maintenance_mode, maintenance_message, maintenance_badge, facebook_url, instagram_url, tiktok_url",
          )
          .eq("id", 1)
          .single();

        if (data && data.maintenance_mode) {
          setIsMaintenance(true);
          // Spremamo sve u jedan objekt (možeš dodati novi state ili iskoristiti postojeći)
          setMaintenanceMessage(data.maintenance_message);
          // Spremit ćemo cijeli data objekt da ga imamo dolje u returnu
          window.maintenanceData = data;
        }
      }
    };

    checkMaintenanceMode();
    // 1. Dohvati session i rolu pri učitavanju
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUserRole(session?.user?.user_metadata?.role || null);
    });

    // 2. Prati promjene (login/logout)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setUserRole(session?.user?.user_metadata?.role || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const isAdmin = userRole === "admin";
  const isWaiter = userRole === "waiter";

  if (isMaintenance) {
    const currentPath = window.location.pathname.toLowerCase();
    const isBackendRoute =
      currentPath.includes("/admin") ||
      currentPath.includes("/konobar") ||
      currentPath.includes("/sank") ||
      currentPath.includes("/inventory");

    if (!isBackendRoute) {
      const d = window.maintenanceData || {};
      return (
        <WebInProgress
          badge={d.maintenance_badge}
          message={maintenanceMessage}
          socials={{
            facebook: d.facebook_url,
            instagram: d.instagram_url,
            tiktok: d.tiktok_url,
          }}
        />
      );
    }
  }

  const PageNotFoundWrapper = () => {
    const navigate = useNavigate();
    return (
      <PageNotFound
        onGoHome={() => navigate("/")}
        onGoBack={() => navigate(-1)}
      />
    );
  };

  return (
    <>
      {showLoading ? (
        <LoadingScreen onFinished={() => setShowLoading(false)} />
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/strijelci"
              element={<HomePage content={<HomeScorers />} />}
            />
            <Route
              path="/zavrsnica"
              element={<HomePage content={<HomeChampionship />} />}
            />
            <Route path="/prvaci-turnira" element={<Arhiva />} />
            <Route path="/pravila-turnira" element={<Rules />} />
            <Route path="/bela-turnir" element={<BelaTurnir />} />
            <Route path="/nagrade" element={<Rewards />} />
            <Route path="/sponzori" element={<Sponsors />} />
            <Route path="/dogadaji" element={<FucaParty />} />
            <Route path="/kako-do-nas" element={<HowToCome />} />
            {/*       <Route path="/novosti" element={<NewsPage />} /> */}
            <Route path="/politika-privatnosti" element={<PrivacyPolicy />} />
            <Route path="/uvjeti-korištenja" element={<TermsOfUse />} />
            <Route
              path="/admin-login"
              element={
                !session ? (
                  <AdminLogin />
                ) : isWaiter ? (
                  <Navigate to="/konobar-home" />
                ) : (
                  <Navigate to="/admin-panel" />
                )
              }
            />
            <Route
              path="/konobar-home"
              element={
                session && (isWaiter || isAdmin) ? (
                  <KonobarHome />
                ) : (
                  <Navigate to="/admin-login" />
                )
              }
            />
            <Route
              path="/sank-panel"
              element={
                session && (isAdmin || isWaiter) ? (
                  <AdminInventory onBack={() => window.history.back()} />
                ) : (
                  <Navigate to="/admin-login" />
                )
              }
            />
            <Route
              path="/admin-panel"
              element={
                session ? (
                  <AdminHome session={session} />
                ) : (
                  <Navigate to="/admin-login" />
                )
              }
            />
            <Route
              path="/sank-panel"
              element={
                session && (isAdmin || isWaiter) ? (
                  <AdminInventory />
                ) : (
                  <Navigate to="/admin-login" />
                )
              }
            />
            <Route
              path="/inventory-edit"
              element={
                session && (isAdmin || isWaiter) ? (
                  <KonobarInventoryEdit onBack={() => window.history.back()} />
                ) : (
                  <Navigate to="/admin-login" />
                )
              }
            />{" "}
            <Route
              path="/inventory-stats"
              element={
                session && (isAdmin || isWaiter) ? (
                  <KonobarStats onBack={() => window.history.back()} />
                ) : (
                  <Navigate to="/admin-login" />
                )
              }
            />
            <Route path="*" element={<PageNotFoundWrapper />} />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
